import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import { cnRadioButton } from '../RadioButton.cn';

import './RadioButton-Content.css';

export type IRadioButtonContentProps = PropsWithChildren<IClassNameProps>;

export const RadioButtonContent: FC<IRadioButtonContentProps> = ({
    className,
    children,
    ...props
}) => (
    <div {...props} className={cnRadioButton('Content', null, [className])}>
        {children}
    </div>
);
